/**
 * Composant de spinner de chargement réutilisable
 */

import { cn } from '@/utils'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  className?: string
  text?: string
}

export function LoadingSpinner({ 
  size = 'md', 
  className,
  text 
}: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  return (
    <div className={cn('flex flex-col items-center justify-center animate-fade-in', className)}>
      <div
        className={cn(
          'animate-spin rounded-full border-2 border-neutral-200 dark:border-neutral-700 border-t-primary-600 dark:border-t-primary-400',
          sizeClasses[size]
        )}
        role="status"
        aria-label="Chargement"
      />
      {text && (
        <p className="mt-3 text-sm text-neutral-500 dark:text-neutral-400 animate-pulse-soft">{text}</p>
      )}
    </div>
  )
}

// ==================== FULL PAGE LOADING ====================

interface FullPageLoadingProps {
  text?: string
}

export const LoadingState = LoadingSpinner

export function FullPageLoading({ text = 'Chargement...' }: FullPageLoadingProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-neutral-950">
      <LoadingSpinner size="lg" text={text} />
    </div>
  )
}